import React from 'react'
import logo from "../../assets/logo/Infused Anlaytics White.png";
import "./style.css";

const Home = ({navigate}) => {

  function nextYear(){
    return new Date().getFullYear() + 1
  }

  return (
    <div className="intro d-md-flex d-block container-fluid vh-100">
    <div className="ps-3 px-md-5  d-flex flex-column justify-content-between align-items-start py-md-0 py-1 text-white text-container">
      <div className="text-start mt-5">
        <p className="fw-bold my-5" style={{fontSize: "42px"}}>
          Empower your data by infusing clinical and financial intelligence
          everywhere.
        </p>
        <p className="mb-3 mb-md-5" style={{ fontSize: "24" }}>
          Welcome to the most sophisticated, AI-driven health analytics engine
          that infuses predictive modeling, public health and institutional
          research with health plan insights at the right place and the right
          time, every time.
        </p>
        <img src={logo} width={450} alt="logo" className="home-logo img-fluid mb-3 d-block d-md-none" />
        <button className="primary-button px-5 py-2" onClick={()=>navigate("/Login")}>Login</button>
      </div>
      <div>
        <p style={{ fontSize: "16px" }}>
          © 2023 - {nextYear()} HUB International Limited. 150 N Riverside Plaza, 17th Floor,
          Chicago, IL 60606. All rights reserved.
        </p>
      </div>
    </div>
    <div className="logo-container h-auto w-auto position-absolute">
      <img src={logo} alt="logo" width={450} className="img-fluid" />
    </div>
  </div>
  )
}

export default Home
